import { OCTUPLE, SINGLE } from "../../../constants/numbers.consts.js";
export default {
    styleOverrides: {
        flexContainer: {
            variants: [
                {
                    props: { orientation: "horizontal" },
                    style: ({ theme }) => ({
                        gap: theme.spacing(OCTUPLE),
                    }),
                },
            ],
        },
        indicator: ({ theme }) => ({
            height: theme.spacing(SINGLE),
            borderTopLeftRadius: theme.spacing(SINGLE),
            borderTopRightRadius: theme.spacing(SINGLE),
        }),
    },
};
